import { Link, useLocation } from 'react-router-dom';

// An address that isn't a page (Oct 2026, Chris's review M13). Both apps redirected silently,
// so a stale bookmark or a typo landed somewhere else with no word of why. This says so, and
// gives the way home.
export default function NotFound({ home, homeLabel }) {
  const { pathname } = useLocation();
  return (
    <main className="grid min-h-screen place-items-center bg-surface-2 px-6" data-testid="not-found">
      <div className="max-w-md text-center">
        <p className="font-heading text-[11px] font-bold uppercase tracking-[0.08em] text-ink-faint">Not found</p>
        <h1 className="mt-2 font-heading text-[24px] font-extrabold text-ink">That page isn&apos;t here</h1>
        <p className="mt-2 text-[14px] text-ink-soft">
          Nothing lives at <code className="rounded bg-white px-1.5 py-0.5 font-mono text-[13px] text-ink">{pathname}</code>. It may have moved, or the address has a typo.
        </p>
        <Link to={home} className="mt-5 inline-flex h-10 items-center rounded-md bg-verlo px-4 text-[14px] font-semibold text-white hover:bg-verlo-hover" data-testid="not-found-home">
          {homeLabel}
        </Link>
      </div>
    </main>
  );
}
